import { html } from '@oskecare/fe-utilities/lib/LitElement/index.js';
import { messageBus } from '../infrastructure.js';
import { config } from '../config.js';

const clickHandler = event => {
  event.preventDefault();

  const expiresAt = new Date();
  expiresAt.setDate(expiresAt.getDate() + 30);
  const localStorageObject = {
    expiresAt,
  };
  localStorage.setItem('osk-b2b-accepted', JSON.stringify(localStorageObject));
  messageBus.publish('router', 'navigate', { path: config.basePath });
};

export default function renderB2bPageTemplate() {
  return html`
    <div class="section">
      <div class="container">
        <div class="grid">
          <div class="grid__col--md-6 hide-md mb-medium">
            <img class="img" src="assets/images/orange-business.png" alt="" />
          </div>
          <div class="grid__col--md-6">
            <div class="grid">
              <div class="grid__col--sm-9 grid__col--md-10 grid__col--lg-9">
                <h1 class="h2 mb-medium">Novinka pre firemných zákazníkov</h1>
              </div>
              <div class="grid__col--sm-9 grid__col--md-10 grid__col--lg-9">
                <p class="large">
                  Máme pre Vás k&nbsp;dispozícii nový portál -
                  <strong>Zákaznícka zóna Orange Business</strong> - určený pre firemných
                  zákazníkov. Vďaka nemu získate prehľad o&nbsp;spotrebe, faktúrach, službách
                  a&nbsp;zariadeniach.
                </p>
              </div>
            </div>
            <a
              href="https://www.orange.sk/biznis/zakaznicka-zona"
              class="btn btn--primary mb-xlarge"
            >
              Viac o&nbsp;Zákazníckej zóne Orange Business
            </a>
            <div class="grid">
              <div class="grid__col--sm-9 grid__col--md-10 grid__col--lg-9">
                <h2>Chcete pokračovať ďalej v&nbsp;zákazníckej zóne Môj Orange?</h2>
              </div>
            </div>
            <a href=${config.basePath} @click=${clickHandler} class="btn">
              Pokračovať v&nbsp;Môj Orange
            </a>
          </div>
          <div class="grid__col--md-6 show-md mb-medium">
            <img class="img-fluid" src="assets/images/orange-business.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  `;
}
